// extracted by mini-css-extract-plugin
module.exports = {"projectList":"healthcare-project-list_projectList__ttr3g","projectList_item":"healthcare-project-list_projectList_item__yZ5tQ"};